import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { ExternalLinksBlockProps, ExternalLinksInteractions } from './partials/ExternalLinksInteractions';
import { ExternalLinksDefaultView } from './views/ExternalLinksDefaultView';

function ExternalLinks({ views, activeView = 'default' }: ExternalLinksBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  switch (active) {
    case true:
      // EditMode
      return <ExternalLinksInteractions views={views} activeView={activeView} />;
    default:
      // LiveMode:
      return <ExternalLinksDefaultView {...views.default} />;
  }
}

export const ExternalLinksBlock = asFetchableBlock(ExternalLinks, BlockType.externallinks);
export type ExternalLinksBlock = ComponentProps<typeof ExternalLinksBlock>;
// same component is used for two different block types.
export const UserExternalLinksBlock = asFetchableBlock(ExternalLinks, BlockType.userexternallinks);
export type UserExternalLinksBlock = ComponentProps<typeof UserExternalLinksBlock>;
